 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A9780715338773_EPUB_COV from '@/components/_9780715338773_epub_cov'
 import LOVE_1 from '@/components/love_1'
 import A9780715338773_EPUB_TP from '@/components/_9780715338773_epub_tp'
 import A9780715338773_EPUB_PART1 from '@/components/_9780715338773_epub_part1'
 import A9780715338773_EPUB_TOC from '@/components/_9780715338773_epub_toc'
 import A9780715338773_EPUB_C1 from '@/components/_9780715338773_epub_c1'
 import A9780715338773_EPUB_C2 from '@/components/_9780715338773_epub_c2'
 import A9780715338773_EPUB_C3 from '@/components/_9780715338773_epub_c3'
 import A9780715338773_EPUB_C4 from '@/components/_9780715338773_epub_c4'
 import A9780715338773_EPUB_C5 from '@/components/_9780715338773_epub_c5'
 import A9780715338773_EPUB_C6 from '@/components/_9780715338773_epub_c6'
 import A9780715338773_EPUB_C7 from '@/components/_9780715338773_epub_c7'
 import A9780715338773_EPUB_C8 from '@/components/_9780715338773_epub_c8'
 import LOVE_2 from '@/components/love_2'
 import A9780715338773_EPUB_PART11 from '@/components/_9780715338773_epub_part11'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/_9780715338773_epub_cov",
 			"name" : "_9780715338773_epub_cov",
 			"component" : A9780715338773_EPUB_COV
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/_9780715338773_epub_tp",
 			"name" : "_9780715338773_epub_tp",
 			"component" : A9780715338773_EPUB_TP
 		},
 		{
 			"path" : "/_9780715338773_epub_part1",
 			"name" : "_9780715338773_epub_part1",
 			"component" : A9780715338773_EPUB_PART1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js